export function FieldError({ children }) {
  if (!children) return null;
  return <span role="alert" className="text-secondary-red text-xs mt-1">{children}</span>;
}

function FormField({ label, htmlFor, required = false, info, error, className = '', labelClassName = '', children }) {
  return (
    <div className={`flex flex-col ${className}`}>
      <div className="flex items-center gap-1 mb-1">
        <label className={`text-sm font-medium text-slate-700 ${labelClassName}`} htmlFor={htmlFor}>
          {label}
          {required && <> <span className="text-secondary-red">*</span></>}
        </label>
        {info}
      </div>
      {children}
      <FieldError>{error}</FieldError>
    </div>
  );
}

/** A FormField wrapping a single text input whose id and name are both `name`. */
export function TextField({ label, name, required = false, info, error, className, type = 'text', ...inputProps }) {
  return (
    <FormField label={label} htmlFor={name} required={required} info={info} error={error} className={className}>
      <input
        id={name}
        name={name}
        type={type}
        required={required}
        className={`input input-bordered text-sm py-2 px-3 h-9 focus:outline-none ${error ? 'input-error' : ''}`}
        {...inputProps}
      />
    </FormField>
  );
}

export default FormField;
